import { useEffect } from 'react';

/**
 * Tags any element React Aria portals to document.body with `data-tailwind`
 * so Tailwind CSS (scoped to [data-tailwind] via PostCSS) applies inside popovers,
 * modals, and tooltips opened on this page.
 *
 * The observer is created on mount and torn down on unmount, so other pages
 * are unaffected.
 */
const useTailwindPortal = () => {
  useEffect(() => {
    const taggedElements: HTMLElement[] = [];

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node instanceof HTMLElement && !node.hasAttribute('data-tailwind')) {
            node.setAttribute('data-tailwind', '');
            taggedElements.push(node);
          }
        }
      }
    });

    observer.observe(document.body, { childList: true });

    return () => {
      observer.disconnect();
      for (const el of taggedElements) {
        el.removeAttribute('data-tailwind');
      }
    };
  }, []);
};

export default useTailwindPortal;
